import { useEndInstructionContext } from '@context/EndInstruction';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';

import { END_INSTRUCTION_VIEW } from '../focuskey';
import Instruction from './components/Instruction';

import * as styles from './styles';

const EndInstructionView = () => {
  const { setButtonFocus } = useEndInstructionContext();

  const { ref } = useFocusable({ focusKey: END_INSTRUCTION_VIEW });

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  return (
    <FocusContext.Provider value={END_INSTRUCTION_VIEW}>
      <div css={styles.container} ref={ref}>
        <div css={styles.backgroundImage} />
        <Instruction />
      </div>
    </FocusContext.Provider>
  );
};

export default EndInstructionView;
